import {ActionType} from '@typescript/common/actionTypes';
import {GENDER} from 'constants/actions';

/**
 * Set current gender
 * @param {number} gender - Gender
 * @returns {ActionType<number>} Action
 */
export function setGender(gender: number): ActionType<number> {
    return {
        type: GENDER.SET,
        payload: gender,
    };
}
